import React, { Component } from 'react';
import _ from 'lodash';
import cogoToast from 'cogo-toast';
import classnames from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { getTimeStampForServer } from '../../Helpers/formatting';

import './BlogPostPreview.scss';

class BlogPostPreview extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,

    // If editing
    canEdit: PropTypes.bool,
    deleteBlogPost: PropTypes.func,
    editBlogPost: PropTypes.func,

    // Styling
    skinny: PropTypes.bool
  };

  state = {
    isEditing: this.props.canEdit && !_.get(this.props.post, 'title'),
    titleField: _.get(this.props.post, 'title') || '',
    subtitleField: _.get(this.props.post, 'subtitle') || '',
    tagField: _.get(this.props.post, 'tag') || '',
    titleStubField: _.get(this.props.post, 'titleStub') || '',
    imageField: _.get(this.props.post, 'coverImage') || ''
  };

  needsSave = () =>
    this.state.titleField !== _.get(this.props.post, 'title') ||
    this.state.subtitleField !== _.get(this.props.post, 'subtitle') ||
    this.state.tagField !== _.get(this.props.post, 'tag') ||
    this.state.titleStubField !== _.get(this.props.post, 'titleStub') ||
    this.state.imageField !== _.get(this.props.post, 'coverImage');

  deletePost = () => {
    const { post, deleteBlogPost } = this.props;
    if (!post.title) {
      deleteBlogPost(post);
    } else {
      confirmAlert({
        title: 'Just confirming',
        message: 'Are you sure you want to delete this blog post?',
        buttons: [
          { label: 'No', className: 'cancel', onClick: () => {} },
          {
            label: 'Yes',
            onClick: () => {
              deleteBlogPost(post);
            }
          }
        ]
      });
    }
  };

  togglePublish = () => {
    const { post } = this.props;
    const { publishedAt } = post;
    this.props
      .editBlogPost(post, {
        publishedAt: publishedAt ? null : getTimeStampForServer()
      })
      .then(
        resp => {
          cogoToast.success(`Successfully ${publishedAt ? 'unpublished' : 'published'} this post.`);
        },
        err => {
          cogoToast.error('There was an issue check the console.');
          console.error(err);
        }
      );
  };
  toggleEditMode = () => {
    const { post } = this.props;
    const { isEditing, titleField, subtitleField, tagField, imageField, titleStubField } = this.state;

    if (isEditing) {
      if (titleStubField.includes('+') || titleStubField.includes('&')) {
        cogoToast.error('Please make sure the stub does not contain special characters.');
        return;
      }

      this.props
        .editBlogPost(post, {
          title: titleField,
          subtitle: subtitleField,
          tag: tagField,
          titleStub: titleStubField,
          coverImage: imageField
        })
        .then(
          resp => {
            this.setState({ isEditing: false });
          },
          err => {
            cogoToast.error('There was an issue check the console.');
            console.error(err);
          }
        );
    } else {
      this.setState({ isEditing: true });
    }
  };

  getSmartTitleStub = input => {
    let seoStub = input
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/|/g, '')
      .replace(/'/g, '')
      .replace(/ \+ /g, '-and-')
      .replace(/\+/g, '-and-')
      .replace(/\s+/g, '-');
    return seoStub;
  };

  render() {
    const { post, canEdit, skinny } = this.props;
    const { isEditing, titleField, subtitleField, tagField, titleStubField, imageField } = this.state;
    const { title, subtitle, coverImage, publishedAt, tag, id } = post;
    const needsSave = this.needsSave();
    return (
      <div
        itemScope
        className={classnames('blog-post-preview-outer-container', {
          editing: isEditing,
          skinny: !!skinny
        })}
      >
        {canEdit && (
          <div className='edit-btns-container'>
            {isEditing && (
              <div onClick={this.deletePost} className='btn delete-post-btn'>
                DELETE
              </div>
            )}
            {isEditing && (
              <div onClick={this.togglePublish} className='btn delete-post-btn'>
                {publishedAt ? 'UNPUBLISH' : 'PUBLISH'}
              </div>
            )}
            <div
              onClick={this.toggleEditMode}
              className={classnames('btn toggle-edit-mode-btn', {
                'needs-save': needsSave
              })}
            >
              {isEditing ? (needsSave ? 'SAVE' : 'DONE') : 'EDIT'}
            </div>
          </div>
        )}
        {!isEditing ? (
          <Link itemProp='url' to={`blog/${post.titleStub}`} onClick={this.navigateToPost} className='blog-post-preview-container'>
            <div className='image-container'>
              {coverImage ? <img src={coverImage} alt={title || `Blog Post ${id}`} /> : <div className='empty-image' />}
            </div>
            <div className='data-container'>
              <div className='tag'>{tag || ''}</div>
              <h2 itemProp='name' className='title'>
                {title || ''}
              </h2>
              <h3 itemProp='description' className='subtitle'>
                {subtitle || ''}
              </h3>
              <div className='read-more'>READ MORE</div>
              {canEdit && !publishedAt && <div className='is-published'>UNPUBLISHED</div>}
            </div>
          </Link>
        ) : (
          <div className='blog-post-edit-container'>
            <input
              placeholder='Title'
              onChange={({ target }) =>
                this.setState({
                  titleField: target.value,
                  titleStubField: this.getSmartTitleStub(target.value)
                })
              }
              value={titleField}
            />
            <input placeholder='Subtitle' onChange={({ target }) => this.setState({ subtitleField: target.value })} value={subtitleField} />
            <input placeholder='Tag' onChange={({ target }) => this.setState({ tagField: target.value })} value={tagField} />
            <input placeholder={`URL stub`} onChange={({ target }) => this.setState({ titleStubField: target.value })} value={titleStubField} />
            <input placeholder={`Cover Image`} onChange={({ target }) => this.setState({ imageField: target.value })} value={imageField} />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(BlogPostPreview);
